// src/admin/pages/ResetPasswordModal.jsx
import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import AdminModal from '../components/AdminModal.jsx';
import { resetUserPassword } from '../adminApi.js';

const inputStyle = {
  width: '100%', padding: '10px 14px', borderRadius: '8px',
  border: '1px solid rgba(0,0,0,0.12)', background: '#ffffff',
  color: '#1d1d1f', fontSize: '14px', boxSizing: 'border-box',
  outline: 'none', fontFamily: "'DM Sans', sans-serif",
};

export default function ResetPasswordModal({ open, onClose, userId }) {
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await resetUserPassword(userId, password);
      setSuccess(true);
      setPassword('');
      setTimeout(() => { setSuccess(false); onClose(); }, 1500);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  function handleClose() {
    setPassword('');
    setError('');
    setSuccess(false);
    onClose();
  }

  return (
    <AdminModal open={open} onClose={handleClose} title="Reset password" width={400}>
      {success ? (
        <div style={{ padding: '16px', textAlign: 'center', color: '#10B981', fontSize: '14px' }}>
          Password aggiornata con successo
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', color: '#6c6c6d', fontSize: '13px', marginBottom: '6px', fontWeight: 500 }}>
              Nuova password
            </label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPw ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                minLength={8}
                style={{ ...inputStyle, paddingRight: '40px' }}
              />
              <button
                type="button"
                onClick={() => setShowPw(v => !v)}
                style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#6c6c6d' }}
              >
                {showPw ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            <span style={{ fontSize: '11px', color: '#6c6c6d', marginTop: '4px', display: 'block' }}>Minimo 8 caratteri</span>
          </div>
          {error && (
            <div style={{ marginBottom: '16px', padding: '10px 14px', borderRadius: '8px', background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)', color: '#EF4444', fontSize: '13px' }}>
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '10px', borderRadius: '8px', border: 'none',
              background: loading ? '#ccc' : '#E8002D', color: '#fff',
              fontSize: '14px', fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Aggiornamento...' : 'Reset password'}
          </button>
        </form>
      )}
    </AdminModal>
  );
}
